module.exports = __webpack_public_path__ + "img/figure-8.50b28e6e.png";